import React from 'react';
import css from './UnlockableContent.module.css';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import { required } from '../../../../../util/validators';

const PriceInputField = ({ fieldName, labelId }) => {
  const intl = useIntl();

  return (
    <div className={css.itemFld}>
      <label htmlFor={`${fieldName}.price`}>
        {intl.formatMessage({
          id: `${labelId}.pricePlaceholder`,
          defaultMessage: 'Enter price',
        })}
      </label>
      <Field
        name={`${fieldName}.price`}
        validate={required(
          intl.formatMessage({
            id: 'UnlockableContent.priceRequired',
            defaultMessage: 'Price is required',
          })
        )}
        component="input"
        type="number"
        placeholder={intl.formatMessage({
          id: `${labelId}.pricePlaceholder`,
          defaultMessage: 'Enter price',
        })}
        className={css.input}
      />
      <Field name={`${fieldName}.price`} subscription={{ error: true, touched: true }}>
        {({ meta }) =>
          meta.error && meta.touched ? (
            <div className={css.error} role="alert">
              {meta.error}
            </div>
          ) : null
        }
      </Field>
    </div>
  );
};

export default PriceInputField;
